<template>
  <section>

    <div class="row">
      <div class="col-md-6">
        <TbFilaAtendimento/>
      </div>
      <div class="col-md-6">
        <TbFilaURA/>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-7">
        <TbFilaAndamento/>
      </div>
      <div class="col-md-5">
        <TbFilaDetail/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <TbUsers ref="tbUsers"/>
      </div>

      <div class="col-md-4">
        <GraficoRespondids/>
        <GraficoOcupacaoAgent/>
      </div>

    </div>

  </section>
</template>

<script>
import TbUsers from "./components/TbUsers";
import GraficoRespondids from "./components/GraficoRespondids";
import GraficoOcupacaoAgent from "./components/GraficoOcupacaoAgent";
import TbFilaAtendimento from "./components/TbFilaAtendimento";
import TbFilaURA from "./components/TbFilaURA";
import TbFilaAndamento from "./components/TbFilaAndamento";
import TbFilaDetail from "./components/TbFilaDetail";

export default {
  name: "RealtimeApp",
  components: {TbFilaAtendimento, TbFilaURA, TbFilaAndamento, TbFilaDetail, GraficoOcupacaoAgent, GraficoRespondids, TbUsers},
}
</script>

<style scoped>
.toogle-el{
  display:none;
}
</style>